import React from 'react'
import './Button.scss'

const styles = {
  wrapper: {
    display: 'block',
    position: 'relative',
    minHeight: '2rem',
  },
  button: {
    outline: 'none',
    border: 'none',
    fontSize: '1.4rem',
    fontFamily: 'Titillium Web',
    fontWeight: '700',
    textTransform: 'uppercase',
  },
  buttonPrimary: {
    height: '4.2rem',
    borderRadius: '2px',
    padding: '0 3rem',
    marginTop: '2rem',
  },
  buttonSecondary: {
    backgroundColor: 'transparent',
  },
  right: {
    position: 'absolute',
    right: '0',
  },
}

const Button = (props) => {
  const { children, secondary, right, inline } = props
  const style = (secondary) ?
    Object.assign({}, styles.button, styles.buttonSecondary)
    :
    Object.assign({}, styles.button, styles.buttonPrimary)
  if (right) Object.assign(style, styles.right)
  if (inline) {
    return (
      <button style={style} className={(secondary) ? 'secondaryButton' : 'primaryButton'}>
        {children}
      </button>
    )
  }
  return (
    <div style={styles.wrapper} >
      <button style={style} className={(secondary) ? 'secondaryButton' : 'primaryButton'}>
        {children}
      </button>
    </div>
  )
}

Button.propTypes = {
  children: React.PropTypes.any,
  secondary: React.PropTypes.bool,
  right: React.PropTypes.bool,
  inline: React.PropTypes.bool,
}

export default Button



// WEBPACK FOOTER //
// ./src/browser/components/Button.js